import { inject } from '@angular/core';
import { BreakpointService, ImageZoomService } from '@core/services';

export function initializeApp() {
  const breakpointService = inject(BreakpointService);
  const imageZoomService = inject(ImageZoomService);
  return Promise.all([breakpointService.observe(), imageZoomService.init()]);
}
